import type { CreativeEditorInstance } from '..';
import { MimeType } from './types';
import { unVectorizeText, vectorizeText } from './vectorizeText';

export async function getVectorPDF(editor: CreativeEditorInstance, page?: number) {
	if (!editor) return null;
	const { scene, block } = editor.engine;

	const currentPage = page ?? scene.getCurrentPage();
	if (currentPage) {
		const outlineColour = block.getStrokeColor(currentPage);
		block.setStrokeColor(currentPage, {
			a: 0,
			b: 0,
			g: 0,
			r: 0,
		});
		const unions = vectorizeText(editor);
		const blob = await block.export(currentPage, MimeType.Pdf);
		unVectorizeText(editor, unions);
		block.setStrokeColor(currentPage, outlineColour);
		return blob;
	}
}

export async function downloadVectorPDF(editor: CreativeEditorInstance, page?: number) {
	const pdf = await getVectorPDF(editor, page);
	if (pdf) {
		const url = URL.createObjectURL(pdf);
		const a = document.createElement('a');
		a.href = url;
		a.download = 'design.pdf';
		a.click();
		URL.revokeObjectURL(url);
	}
}
